enum CoparticipationColumnIdEnum {
  PartnerCompany = 'partnerCompany',
  Beneficiary = 'beneficiaryName',
  Holder = 'holderName',
  Total = 'totalCoparticipation',
  CancelDate = 'cancellationDate',
}

enum CoparticipationSubRowColumnIdEnum {
  Code = 'procedureCode',
  Description = 'procedureDescription',
  Provider = 'corporateReason',
  AuthorizationDate = 'authorizationDate',
  Value = 'coparticipationValue',
}

interface ColumnsBaseProps {
  label: string;
  align?: 'right' | 'left' | 'inherit' | 'center' | 'justify';
  width: string;
}

interface ColumnsMainRowProps extends ColumnsBaseProps {
  id: CoparticipationColumnIdEnum;
}

interface ColumnsSubRowProps extends ColumnsBaseProps {
  id: CoparticipationSubRowColumnIdEnum;
}

export {
  ColumnsSubRowProps,
  ColumnsMainRowProps,
  CoparticipationSubRowColumnIdEnum,
  CoparticipationColumnIdEnum,
};
